import '../../scss/theme.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { config, dom, library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faInstagram, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

config.autoAddCss = false;
library.add(faFacebookF, faInstagram, faXTwitter, faYoutube);
dom.watch();

document.documentElement.classList.add('has-js');

(function () {
	'use strict';

	const toggle = document.querySelector('[data-menu-toggle]');
	const nav = document.querySelector('[data-primary-nav]');

	if (!toggle || !nav) {
		return;
	}

	toggle.addEventListener('click', function () {
		const isOpen = toggle.getAttribute('aria-expanded') === 'true';
		toggle.setAttribute('aria-expanded', String(!isOpen));
		nav.classList.toggle('is-open', !isOpen);
	});
})();

(function () {
	'use strict';

	const switcher = document.querySelector('[data-language-switcher]');

	if (!switcher) {
		return;
	}

	const toggle = switcher.querySelector('[data-language-toggle]');

	if (!toggle) {
		return;
	}

	const close = () => {
		switcher.classList.remove('is-open');
		toggle.setAttribute('aria-expanded', 'false');
	};

	toggle.addEventListener('click', () => {
		const isOpen = toggle.getAttribute('aria-expanded') === 'true';
		switcher.classList.toggle('is-open', !isOpen);
		toggle.setAttribute('aria-expanded', String(!isOpen));
	});

	document.addEventListener('click', (event) => {
		if (!switcher.contains(event.target)) {
			close();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			close();
		}
	});
})();

(function () {
	'use strict';

	const accordions = document.querySelectorAll('.support-type__details');

	if (!accordions.length) {
		return;
	}

	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	const getBody = (details) => details.querySelector('.support-type__body');

	const setOpenHeight = (body) => {
		body.style.maxHeight = `${body.scrollHeight}px`;
	};

	accordions.forEach((details) => {
		const summary = details.querySelector('summary');
		const body = getBody(details);

		if (!summary || !body) {
			return;
		}

		if (details.open) {
			setOpenHeight(body);
		}

		summary.addEventListener('click', (event) => {
			if (prefersReducedMotion.matches) {
				return;
			}

			event.preventDefault();

			if (details.open) {
				setOpenHeight(body);

				window.requestAnimationFrame(() => {
					body.style.maxHeight = '0px';
				});

				body.addEventListener('transitionend', function handleClose(transitionEvent) {
					if (transitionEvent.propertyName !== 'max-height') {
						return;
					}

					details.removeAttribute('open');
					body.removeEventListener('transitionend', handleClose);
				});

				return;
			}

			details.setAttribute('open', '');
			body.style.maxHeight = '0px';

			window.requestAnimationFrame(() => {
				setOpenHeight(body);
			});
		});
	});

	window.addEventListener('resize', () => {
		accordions.forEach((details) => {
			const body = getBody(details);
			if (details.open && body) {
				setOpenHeight(body);
			}
		});
	});
})();

(function () {
	'use strict';

	const modal = document.querySelector('[data-video-modal]');
	const triggers = document.querySelectorAll('[data-video-trigger]');

	if (!modal || !triggers.length) {
		return;
	}

	const dialog = modal.querySelector('[role="dialog"]');
	const title = modal.querySelector('[data-video-title]');
	const frame = modal.querySelector('[data-video-frame]');
	const closeButtons = modal.querySelectorAll('[data-video-close]');
	const focusableSelector = [
		'a[href]',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'input:not([disabled])',
		'select:not([disabled])',
		'[tabindex]:not([tabindex="-1"])',
	].join(',');
	let activeTrigger = null;

	const getFocusableElements = () => Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => {
		return !element.hasAttribute('disabled') && element.offsetParent !== null;
	});

	const closeModal = () => {
		modal.setAttribute('hidden', '');
		document.body.classList.remove('has-video-modal');
		frame.innerHTML = '';
		document.removeEventListener('keydown', handleKeydown);

		if (activeTrigger) {
			activeTrigger.focus();
			activeTrigger = null;
		}
	};

	function handleKeydown(event) {
		if (event.key === 'Escape') {
			event.preventDefault();
			closeModal();
			return;
		}

		if (event.key !== 'Tab') {
			return;
		}

		const focusableElements = getFocusableElements();
		if (!focusableElements.length) {
			event.preventDefault();
			dialog.focus();
			return;
		}

		const firstElement = focusableElements[0];
		const lastElement = focusableElements[focusableElements.length - 1];

		if (event.shiftKey && document.activeElement === firstElement) {
			event.preventDefault();
			lastElement.focus();
		} else if (!event.shiftKey && document.activeElement === lastElement) {
			event.preventDefault();
			firstElement.focus();
		}
	}

	const openModal = (trigger) => {
		const youtubeId = trigger.getAttribute('data-youtube-id');
		const videoTitle = trigger.getAttribute('data-video-title') || 'Video';

		if (!youtubeId || !/^[A-Za-z0-9_-]{6,20}$/.test(youtubeId)) {
			return;
		}

		activeTrigger = trigger;
		title.textContent = videoTitle;
		frame.innerHTML = '';

		const iframe = document.createElement('iframe');
		iframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`;
		iframe.title = videoTitle;
		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
		iframe.allowFullscreen = true;
		frame.appendChild(iframe);

		modal.removeAttribute('hidden');
		document.body.classList.add('has-video-modal');
		document.addEventListener('keydown', handleKeydown);

		const focusableElements = getFocusableElements();
		(focusableElements[0] || dialog).focus();
	};

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (event) => {
			event.preventDefault();
			openModal(trigger);
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener('click', closeModal);
	});
})();
